import type { ReactNode } from "react";
import { ChevronDown, Crosshair } from "lucide-react";

/*
 * Gezeichnete Mini-Ansichten statt Screenshots: sie folgen den Tokens, brauchen
 * keine Binär-Assets und veralten nicht mit jedem Pixel der echten UI. Rein
 * dekorativ — die Information steckt im Text des Schritts.
 */

const radarSrc = "/assets/maps/de_mirage_radar.png";

export function Frame({ children }: { children: ReactNode }) {
  return <div className="ob-ill">{children}</div>;
}

export function Chip({
  children,
  hl,
  tone,
}: {
  children: ReactNode;
  hl?: boolean;
  tone?: "accent" | "route" | "warning" | "muted" | "primary";
}) {
  return (
    <span
      className={`ob-chip${tone ? ` is-${tone}` : ""}${hl ? " ob-hl" : ""}`}
    >
      {children}
    </span>
  );
}

export function Select({
  label,
  value,
  hl,
}: {
  label: string;
  value: string;
  hl?: boolean;
}) {
  return (
    <span className={`ob-select${hl ? " ob-hl" : ""}`}>
      <small>{label}</small>
      <span>
        {value}
        <ChevronDown />
      </span>
    </span>
  );
}

export function Frames({ hl }: { hl?: boolean }) {
  return (
    <span className={`ob-frames${hl ? " ob-hl" : ""}`}>
      {["START", "AIM", "RESULT"].map((label) => (
        <span key={label}>
          <Crosshair />
          <small>{label}</small>
        </span>
      ))}
    </span>
  );
}

/** Radar als Hintergrund; das SVG darüber nutzt ein 300×100-Raster (3:1 wie der Rahmen). */
export function Radar({
  children,
  overlay,
}: {
  children?: ReactNode;
  overlay?: ReactNode;
}) {
  return (
    <div className="ob-radar">
      <img src={radarSrc} alt="" />
      <svg viewBox="0 0 300 100">{children}</svg>
      {overlay}
    </div>
  );
}

export function Rail({ children }: { children: ReactNode }) {
  return <span className="ob-rail">{children}</span>;
}

export function Row({ children }: { children: ReactNode }) {
  return <span className="ob-row">{children}</span>;
}

export const routePoints = [
  [43, 80],
  [102, 61],
  [161, 64],
  [220, 35],
] as const;
export const route = `M${routePoints.map(([x, y]) => `${x} ${y}`).join(" L")}`;
